export enum LANGUAGE {
  SET_LANGUAGE = "SET_LANGUAGE",
}

export const setLanguage = (payload) => ({
  type: LANGUAGE.SET_LANGUAGE,
  payload,
});
